import { styled } from '@mui/material/styles';
import type { JSX } from 'react';
import Image from '../Image';
import { ImageProps } from '../Image/Image';

const Container = styled('div', { name: 'ImageContainer' })({
  flex: 1,
  position: 'relative',
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
});

interface CardImageProps extends Omit<ImageProps, 'src'> {
  src?: string;
  fallback?: JSX.Element;
}

export const CardImage = ({ src, fallback, ...props }: CardImageProps) => {
  return (
    <Container>
      {src || props.isLoading ? (
        <Image
          src={src}
          size="md"
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            objectFit: 'contain',
          }}
          {...props}
        />
      ) : (
        fallback
      )}
    </Container>
  );
};
